import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: David Koníř
 * id EA63161B-B010-4BEC-A5B0-774C2007C0D0
 * name data-matrix-minus
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/data-matrix-minus.svg
 * tags
 */
export const DataMatrixMinusIcon = createSvgIcon(<><path d="M16 2V4H14V2H16M12 2H10V6H12V2M10 14H8V16H10V14M16 4V6H14V8H18V4H16M8 2H6V6H8V2M20 2H18V4H20V2M13.8 22H2V2H4V6H6V12H4V14H6V16H8V18H10V20H12V18H10V16H12V12H8V8H12V10H14V12H16V10H18V12H22V13.8C21.1 13.3 20.1 13 19 13C17.8 13 16.6 13.4 15.7 14H14V15.7C13.4 16.6 13 17.8 13 19C13 20.1 13.3 21.1 13.8 22M6 18H4V20H6V18M22 8H18V10H22V8M22 6V4H20V6H22M15 18V20H23V18H15Z" /></>, 'DataMatrixMinusIcon');
export default DataMatrixMinusIcon